import { Route } from '@/types/route'

export const attendanceTabRoutes: Route[] = [
  {
    path: 'boarding-attendance-reports',
    name: 'boarding-attendance-report-list',
    component: () =>
      import(
        '@/views/Attendance/AttendanceReportList/AttendanceReportView.vue'
      ),
    meta: {
      icon: 'calendar',
      title: 'Attendance report',
      tab: 'boarding',
      permissions: ['boarding_attendances.view_boardingattendancereport']
    }
  },

  {
    name: 'campus-absence-list',
    path: 'campus-absences',
    component: () =>
      import('@/views/Attendance/CampusAbsence/CampusAbsenceView.vue'),
    meta: {
      icon: 'carry-out',
      title: 'Campus absence',
      tab: 'boarding',
      permissions: ['campus_absences.view_campusabsence']
    }
  },

  {
    path: 'leaves',
    name: 'leave-request-list',
    component: () =>
      import('@/views/Attendance/LeaveRequest/LeaveRequestView.vue'),
    meta: {
      icon: 'schedule',
      title: 'Leave requests',
      tab: 'boarding',
      permissions: ['leaves.view_leaverequest']
    }
  },
  {
    path: 'night-attendance-reports',
    name: 'night-attendance-report-list',
    component: () =>
      import(
        '@/views/Attendance/NightRoomingReport/NightRoomingReportView.vue'
      ),
    meta: {
      icon: 'home',
      title: 'Night rooming',
      tab: 'boarding',
      permissions: ['boarding_night_attendances.view_nightattendancereport']
    }
  }
]

const attendanceNotTabRoutes = [
  {
    path: 'boarding-attendance-reports/:id',
    component: () =>
      import('@/views/Attendance/AttendanceReportDetails/index.vue'),
    name: 'boarding-attendance-report-details',
    meta: {
      title: 'Boarding Attendances Reports Details',
      tab: 'boarding',
      permissions: ['boarding_attendances.view_boardingattendancereport']
    }
  },
  {
    path: 'night-attendance-reports/:id',
    component: () =>
      import('@/views/Attendance/NightRoomingReportDetails/index.vue'),
    name: 'night-attendance-report-details',
    meta: {
      title: 'Boarding Attendances Reports Details',
      tab: 'boarding',
      permissions: ['boarding_night_attendances.view_nightattendancereport']
    }
  }
]

export const attendanceRoutes = [
  {
    name: 'attendance',
    path: 'attendance',
    component: () => import('@/views/Attendance/AttendanceView.vue'),
    meta: {
      tab: 'boarding',
      title: 'Attendance'
    },
    children: attendanceTabRoutes
  },
  {
    path: 'attendance',
    component: () => import('@/views/Layouts/RouterView.vue'),
    meta: {
      tab: 'boarding'
    },
    children: attendanceNotTabRoutes
  }
]
